import React from "react";
import { createRoot } from 'react-dom/client'

import { RelacionamentoAutocomplete } from './components/relacionamento-autocomplete';
import { FormRelatorioModeloOpcao } from './components/form-relatorio-modelo-opcao';
import { BotaoUploadRelatorio } from './components/botao-upload-relatorio';
import { AutocompleteLotacao } from './components/autocomplete-lotacao';
import { TabelaLogGeracao } from "./components/tabela-log-geracao";
import { FormListaAtividades } from "./components/form-lista-atividades";
import { PhotoCapture } from "./components/photo-capture";
import { FormRelatorioUploadArquivos  } from "./components/form-relatorio-upload-arquivos"
import { AutocompleteUsuario } from './components/autocomplete-usuario';


/**
 * 
 * Função temporaria enquanto não é possivel utilizar a gem react_on_rails
 */
function register(components = {}) {
  document.addEventListener("readystatechange", function () {
    if (document.readyState == 'interactive') {
      for (let componentName of Object.keys(components)) {
        const Component = components[componentName];
        const nodes = document.getElementsByClassName(`${componentName}-ReactComponent`);

        if (nodes) {
          for (let node of nodes) {
            const propsElement = document.getElementById(`${node.id}-props`);
            const props = JSON.parse(propsElement.textContent);
            createRoot(node).render(<Component {...props} />);
          }
        }
      }
    }
  })
}

register({
  RelacionamentoAutocomplete,
  FormRelatorioModeloOpcao,
  BotaoUploadRelatorio,
  AutocompleteLotacao,
  AutocompleteUsuario,
  TabelaLogGeracao,
  FormListaAtividades,
  PhotoCapture,
  FormRelatorioUploadArquivos
})
